export type NotificationCategory = 'system' | 'task' | 'activity';

export const NOTIFICATION_CATEGORY_LABELS: Record<NotificationCategory, string> = {
  system: '系统',
  task: '任务',
  activity: '活动',
};

export const ALL_NOTIFICATION_CATEGORIES: NotificationCategory[] = ['system', 'task', 'activity'];

export interface AdminNotificationDTO {
  id: number;
  market_id: string;
  category: NotificationCategory;
  title: string;
  summary: string;
  body: string;
  action_label?: string;
  created_by?: number;
  created_at: string;
  updated_at: string;
}

export interface AdminNotificationListResponseDTO {
  items: AdminNotificationDTO[];
  total: number;
  page: number;
  page_size: number;
}

export interface UpsertAdminNotificationRequest {
  market_id: string;
  category: NotificationCategory;
  title: string;
  summary: string;
  body: string;
  action_label?: string;
}
